export const zh = {
  system_name: 'CDN用户诊断系统',
  system_check_button: '检测',
  ip_info: 'IP信息',
  local_ip: '本地IP:',
  local_dns: 'LocalDNS:',
  probe_sever_info: '探测服务器信息',
  domain_name: '域名:',
  recommend_resolution_ip: '推荐解析IP:',
  status_code: '状态码:',
  network_delay: '网络时延:',
  download_speed: '下载速度:',
  system_environment_information: '系统环境信息',
  time: '时间:',
  user_agent: 'User Agent:',
  footer_copyright: '版权所有 © 华为软件技术有限公司 2020 保留一切权利'

}



//////////////////
// WEBPACK FOOTER
// ./static/zh.js
// module id = null
// module chunks = 